

























































































































































































































import Button from "@/shared/components/ui/Button.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import { PlanType, FetchState, PlanDetails } from "@/shared/types";
import * as _ from "lodash";
import moment from "moment";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useWizardStore } from "@/employee/store/wizard";
import { useSignUpStore } from "@/employee/store/signup";
import { useContributionStore } from "@/shared/store/contribution";

@Component({
  components: {
    RadioButton,
    Button
  }
})
export default class IndividualPlanDetails extends Vue {
  signupStore = useSignUpStore();
  contactInfoStore = useContactInfoStore();
  wizardStore = useWizardStore();
  contributionStore = useContributionStore();

  PlanType = PlanType;

  @Prop()
  inWizard: boolean;
  isSubmitting = false;
  showContributions = true;
  formModel: PlanDetails = {
      planType: PlanType.Individual,
      effectiveDate: moment().format("YYYY-MM-DD"),
      otherHsaAmount: 0,
      enrollHsa: true
    };

  resetForm () {
    this.formModel = {
      planType: PlanType.Individual,
      effectiveDate: moment().format("YYYY-MM-DD"),
      otherHsaAmount: 0,
      enrollHsa: false
    };
  }

  mounted () {
    this.signupStore.getContributionLimits();
    this.contributionStore.getPlanDetails();
    this.contactInfoStore.getContactInformation();
    this.syncData();
  }

  syncData () {
    this.formModel = _.cloneDeep(this.contributionStore.planDetails);
    this.showContributions = this.formModel.otherHsaAmount > 0;
  }

  @Watch("contributionStore.planDetails")
  onPlanStateChanged () {
    this.syncData();
  }

  get isLoaded () {
    return this.contactInfoStore.contactInformationState === FetchState.Loaded
      && this.signupStore.isLoaded
      && this.contributionStore.planDetailsFetchState === FetchState.Loaded;
  }

  onSubmit () {
    if (this.isSubmitting) return;

    this.isSubmitting = true;
    this.$validator.validateAll().then(result => {
      if (!result) {
        this.isSubmitting = false;
        return;
      }
      this.contributionStore.savePlanDetails(this.formModel).then(() => {
        this.wizardStore.getWizardState();
        this.$emit("complete");
        this.$emit("isFamilyPlan", this.formModel.planType === PlanType.Family);
        this.isSubmitting = false;
      })
      .catch(() => this.isSubmitting = false);
    });
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  get showContributionSection () {
    if (!this.formModel.enrollHsa) return false;

    return this.formModel.effectiveDate === null
      || new Date(this.formModel.effectiveDate).getFullYear() < new Date().getFullYear() + 1;
    }
}
